export * from './partner.page'
